import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  Output,
  Renderer2,
} from '@angular/core';
import { RecaptchaService } from './recaptcha.service';
import { environment } from '../../../../environments/environment';
import { WindowRef } from '@spartacus/core';

export interface InjectAndLoadScriptConfig {
  scriptSrc: string;
  siteKey: string;
  onloadCallbackName: string;
  onLoadCallback(): void;
  onErrorCallback(err: any): void;
}

@Component({
  selector: 'recaptcha',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ``,
  standalone: false
})
export class RecaptchaComponent implements OnDestroy {
  @Output() scriptLoad = new EventEmitter<void>();
  @Output() scriptError = new EventEmitter<ErrorEvent>();
  private recaptchaAPI: {
    render: (elementId: string, opts: any) => string;
    getResponse: (widgetId: string) => any;
  };

  constructor(
    protected recaptchaService: RecaptchaService,
    protected renderer: Renderer2,
    protected element: ElementRef,
    protected winRef: WindowRef
  ) {
    this.setGlobalHandlers();
    this.injectGoogleRecaptchaScript();
  }

  ngOnDestroy(): void {
    this.unsetGlobalHandlers();
  }

  private setGlobalHandlers(): void {
    if (!!this.winRef.nativeWindow) {
      this.winRef.nativeWindow[environment?.recaptchaV3?.onloadCallbackName] = () => {
        this.recaptchaAPI = (this.winRef.nativeWindow as any).grecaptcha;
      };
    }
  }

  private unsetGlobalHandlers(): void {
    if (this.winRef?.nativeWindow) {
      delete this.winRef.nativeWindow[environment?.recaptchaV3?.onloadCallbackName];
    }
  }

  /**
   * Create a <script> element and inject it into the page in order
   * to load the recaptcha lib. Emit load or error events from the relevant
   * Outputs to the component
   */
  private injectGoogleRecaptchaScript(): void {
    this.recaptchaService.initRecaptcha();
  }
}
